import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	height: 100%;

	iframe {
		flex: 1 1 0;
		min-height: 0;
	}
`;
